/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type STORY_MODE = "COMMENTS" | "QA" | "%future added value";
export type ModerationActionsContainer_story = {
    readonly id: string;
    readonly settings: {
        readonly mode: STORY_MODE;
    };
    readonly " $refType": "ModerationActionsContainer_story";
};
export type ModerationActionsContainer_story$data = ModerationActionsContainer_story;
export type ModerationActionsContainer_story$key = {
    readonly " $data"?: ModerationActionsContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerationActionsContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerationActionsContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "StorySettings",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mode",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '6bf92bb5d1251672e1b309acfe172450';
export default node;
